import { MapGeoJSONFeature } from "maplibre-gl";

import { useFileDescriptorQuery } from "@/queries/query-file-descriptors";
import { isTypedDescriptor } from "@/utils/is-descriptor-type";

import { PopupContent } from "./popup-content";
import { StorageCurveGraph } from "./storage-curve-graph";

export function VectorInfo({
  feature,
  descriptorId,
  layerName,
}: {
  feature: MapGeoJSONFeature | null;
  descriptorId: string;
  layerName: string;
}) {
  const { data: descriptor } = useFileDescriptorQuery(descriptorId);
  const vectorDescriptor = isTypedDescriptor(descriptor, "vector") ? descriptor : undefined;

  if (!feature) return null;

  const tables = vectorDescriptor?.meta.tables ?? {};
  const table = Object.values(tables).find((t) => t.layerId === layerName);

  if (table) {
    return (
      <StorageCurveGraph descriptorId={descriptorId} table={table} featureId={String(feature.id)} />
    );
  }

  const properties = feature.properties || {};
  return (
    <PopupContent>
      {Object.entries(properties).map(([key, value]) => (
        <PopupContent.Item key={key} label={key} {...{ value }} />
      ))}
    </PopupContent>
  );
}
